import CrearPerfil from "pages/LandingPages/CrearPerfil/crearPerfil";

export default function CrearPerfilPage() {
  return <CrearPerfil />;
}
